import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    alias:['/index.html'],
    component: Home
  },
  {
    path: '/desarrollo-sitios-web',
    name: 'SitiosWeb',
    alias:['/desarrollo-sitios-web.html'],
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/SitiosWeb.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // If a hash is present in the `to` route, scroll to the element
      return {
        el: to.hash, // 'el' property specifies the target element selector
        behavior: "smooth", // Optional: adds smooth scrolling
      };
    } else if (savedPosition) {
      // If a saved scroll position exists (e.g., from browser back/forward)
      return savedPosition;
    } else {
      // Default: scroll to the top of the page
      return { x: 0, y: 0 };
    }
  },
})

export default router
